import { useReexecuteQueryWhenInputsChange, useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetSurveyResponseByIdDocument, GetSurveyResponseByIdQuery } from '../generated/survey-responses';

type SurveyResponse = Omit<NonNullable<GetSurveyResponseByIdQuery['getSurveyResponseById']>, '__typename'>;

export type { SurveyResponse };

export const useSurveyResponse = (surveyResponseId?: string): { data?: SurveyResponse; fetching: boolean } => {
  const [{ data, fetching }, reexecute] = useSecureGraphqlQuery<GetSurveyResponseByIdQuery>({
    pause: true,
    query: GetSurveyResponseByIdDocument,
    variables: {
      id: surveyResponseId ?? '',
    },
  });
  useReexecuteQueryWhenInputsChange(reexecute, surveyResponseId);

  return { data: data?.getSurveyResponseById ?? undefined, fetching };
};
